export const ATTRIBUTES = {
	Capacitance: 'C',
	CapacitorImpedanceESR: 'ESR', // When capacitor DB will be cleared this will be substitutted with ESR @ SRF
	CapacitorImpedanceESR_SRF: 'ESR', // ESR @ SRF from TAYO YUDEN Database
	Inductance: 'L',
	Lp: 'Lp',
	TurnsRatio: 'TR',
	Rp: 'Rp',
	Rs: 'Rs',
	InductorDCResistance: 'DCR',
	Resistance: 'R'
};

/* Components that have something else to show (attributes, quantity,..). For example: 'Cout' has 'C', 'ESR', 'Qty'. */
export const COMPONENTS = {
	IC: {
		part: 'IC',
		showPartNumber: true,
		showQuantity: false,
		attributes: []
	},
	ICiso: {
		part: 'ICiso',
		showPartNumber: true,
		showQuantity: false,
		attributes: []
	},
	HS: {
		part: 'Qhs',
		showPartNumber: true,
		showQuantity: false,
		attributes: []
	},
	LS: {
		part: 'Qls',
		showPartNumber: true,
		showQuantity: false,
		attributes: []
	},
	Q: {
		part: 'Q',
		showPartNumber: true,
		showQuantity: false,
		attributes: []
	},
	Cin: {
		part: 'Cin',
		showPartNumber: true,
		showQuantity: true,
		attributes: ['Capacitance', 'CapacitorImpedanceESR', 'CapacitorImpedanceESR_SRF']
	},
	Cout: {
		part: 'Cout',
		showPartNumber: true,
		showQuantity: true,
		attributes: ['Capacitance', 'CapacitorImpedanceESR', 'CapacitorImpedanceESR_SRF']
	},
	Cbias: {
		part: 'Cbias',
		showPartNumber: true,
		showQuantity: true,
		attributes: ['Capacitance', 'CapacitorImpedanceESR', 'CapacitorImpedanceESR_SRF']
	},
	Cff: {
		part: 'Cff',
		showPartNumber: true,
		showQuantity: true,
		attributes: ['Capacitance', 'CapacitorImpedanceESR', 'CapacitorImpedanceESR_SRF']
	},
	Cadj: {
		part: 'Cadj',
		showPartNumber: true,
		showQuantity: true,
		attributes: ['Capacitance', 'CapacitorImpedanceESR', 'CapacitorImpedanceESR_SRF']
	},
	C1: {
		part: 'C1',
		showPartNumber: false,
		showQuantity: false,
		attributes: ['Capacitance', 'CapacitorImpedanceESR', 'CapacitorImpedanceESR_SRF']
	},
	C2: {
		part: 'C2',
		showPartNumber: false,
		showQuantity: false,
		attributes: ['Capacitance', 'CapacitorImpedanceESR', 'CapacitorImpedanceESR_SRF']
	},
	C3: {
		part: 'C3',
		showPartNumber: false,
		showQuantity: false,
		attributes: ['Capacitance', 'CapacitorImpedanceESR', 'CapacitorImpedanceESR_SRF']
	},
	C4: {
		part: 'C4',
		showPartNumber: false,
		showQuantity: false,
		attributes: ['Capacitance', 'CapacitorImpedanceESR', 'CapacitorImpedanceESR_SRF']
	},
	C5: {
		part: 'C5',
		showPartNumber: false,
		showQuantity: false,
		attributes: ['Capacitance', 'CapacitorImpedanceESR', 'CapacitorImpedanceESR_SRF']
	},
	Csn: {
		part: 'Csn',
		showPartNumber: true,
		showQuantity: false,
		attributes: ['Capacitance', 'CapacitorImpedanceESR', 'CapacitorImpedanceESR_SRF']
	},
	Cdc: {
		part: 'Cdc',
		showPartNumber: true,
		showQuantity: false,
		attributes: ['Capacitance', 'CapacitorImpedanceESR', 'CapacitorImpedanceESR_SRF']
	},
	Lout: {
		part: 'Lout',
		showPartNumber: true,
		showQuantity: false,
		attributes: ['Inductance', 'InductorDCResistance']
	},
	T: {
		part: 'T',
		showPartNumber: false,
		showQuantity: false,
		attributes: ['Lp', 'Rp', 'Rs', 'TurnsRatio']
	},
	D: {
		part: 'D',
		showPartNumber: true,
		showQuantity: false,
		attributes: []
	},
	D1: {
		part: 'D1',
		showPartNumber: true,
		showQuantity: false,
		attributes: []
	},
	D2: {
		part: 'D2',
		showPartNumber: true,
		showQuantity: false,
		attributes: []
	},
	D3: {
		part: 'D3',
		showPartNumber: true,
		showQuantity: false,
		attributes: []
	},
	D4: {
		part: 'D4',
		showPartNumber: true,
		showQuantity: false,
		attributes: []
	},
	Dsn: {
		part: 'Dsn',
		showPartNumber: true,
		showQuantity: false,
		attributes: []
	},
	Dout: {
		part: 'Dout',
		showPartNumber: true,
		showQuantity: false,
		attributes: []
	},
	Rbot: {
		part: 'Rbot',
		showPartNumber: true,
		showQuantity: false,
		attributes: ['Resistance']
	},
	Rtop: {
		part: 'Rtop',
		showPartNumber: true,
		showQuantity: false,
		attributes: ['Resistance']
	},
	Rs: {
		part: 'Rs',
		showPartNumber: true,
		showQuantity: false,
		attributes: ['Resistance']
	},
	Rsn: {
		part: 'Rsn',
		showPartNumber: true,
		showQuantity: false,
		attributes: ['Resistance']
	}
};
